import discoveredArticles from "./generatedCatalog";

export const ARTICLE_CATEGORIES = [
  "AI & Machine Learning",
  "Data & Analytics",
  "Operations & Decision Systems",
  "Transportation & Mobility",
  "Leadership & Growth",
];

export const ARTICLE_CATEGORY_SLUGS = {
  "AI & Machine Learning": "ai-machine-learning",
  "Data & Analytics": "data-analytics",
  "Operations & Decision Systems": "operations-decision-systems",
  "Transportation & Mobility": "transportation-mobility",
  "Leadership & Growth": "leadership-growth",
};

export const ARTICLE_CATEGORY_BY_SLUG = Object.fromEntries(
  Object.entries(ARTICLE_CATEGORY_SLUGS).map(([label, slug]) => [slug, label])
);

const legacyArticles = [
  {
    slug: "thepowerofdata",
    title: "The Power of Data: A New Era of Influence",
    by: "Mohamed Gad",
    date: "2025-07-18",
    category: "Data & Analytics",
    topics: ["Data Science & Infrastructure"],
    summary:
      "Data has become a source of institutional power. This article explores how organizations can build the infrastructure, judgment, and accountability needed to turn information into durable influence.",
    cover_image:
      "https://incubator.ucf.edu/wp-content/uploads/2023/07/artificial-intelligence-new-technology-science-futuristic-abstract-human-brain-ai-technology-cpu-central-processor-unit-chipset-big-data-machine-learning-cyber-mind-domination-generative-ai-scaled-1-1500x1000.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-1" */ "./Article1"),
  },
  {
    slug: "callcenter-prescriptive-framework",
    title:
      "From Forecasting to Foresight: A Prescriptive Framework for Call Center Optimization",
    by: "Mohamed Gad",
    date: "2025-07-20",
    category: "Operations & Decision Systems",
    topics: ["Prescriptive Modeling"],
    summary:
      "Forecasting demand is only the beginning. This framework connects expected call volume to staffing, service levels, and operational choices so leaders can move from prediction to practical action.",
    cover_image:
      "https://d15shllkswkct0.cloudfront.net/wp-content/blogs.dir/1/files/2024/08/a-futuristic-image-of-a-bustling-ai-contact-center-HTLUyOk5Q7GGMVJrKGPKkw-1LeyLqOZSIGRHaO1BdihAA.jpeg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-2" */ "./Article2"),
  },
  {
    slug: "will-we-ever-build-jarvis",
    title:
      "Will We Ever Build J.A.R.V.I.S.? A Pragmatic Look at the Mind, Body, and Soul of AI",
    by: "Mohamed Gad",
    date: "2025-07-27",
    category: "AI & Machine Learning",
    topics: ["AI Systems & Tech Ethics"],
    summary:
      "A grounded examination of what a J.A.R.V.I.S.-like system would actually require, from reasoning and embodiment to memory, trust, ethics, and the limits of today’s artificial intelligence.",
    cover_image: "https://www.unite.ai/wp-content/uploads/2024/12/Tactile-Robots.webp",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-3" */ "./Article3"),
  },
  {
    slug: "state-of-the-art-can-be-simple",
    title: "State-of-the-Art Can Be Simple and Strategic",
    by: "Mohamed Gad",
    date: "2025-08-12",
    category: "AI & Machine Learning",
    topics: ["Data Science & Infrastructure"],
    summary:
      "Sophisticated results do not always require complicated systems. This article argues for disciplined simplicity, showing how focused models and strategic implementation can outperform unnecessarily elaborate technical stacks.",
    cover_image:
      "https://media.licdn.com/dms/image/v2/D4E12AQFgsxBONkylCQ/article-cover_image-shrink_720_1280/B4EZYsdTVpG0AI-/0/1744502603804?e=2147483647&v=beta&t=Se-OmgumoZL96LoIqrCGFC0_2nSlLhJ46XpcOGGtD8g",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-4" */ "./Article4"),
  },
  {
    slug: "can-the-us-win-the-ai-race-with-debt-laden-students",
    title: "Can the U.S. Win the AI Race While Students Drown in Debt?",
    by: "Mohamed Gad",
    date: "2025-08-13",
    category: "Leadership & Growth",
    topics: ["AI Policy & Higher Education"],
    summary:
      "America’s AI ambitions depend on talent, yet education debt constrains the people expected to build the future. This piece connects national competitiveness, higher education policy, and economic opportunity.",
    cover_image:
      "https://www.digiexam.com/hs-fs/hubfs/Digiexam_AI%20in%20education_Illustration_v1.2.png?width=1920&name=Digiexam_AI%20in%20education_Illustration_v1.2.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-5" */ "./Article5"),
  },
  {
    slug: "building-data-culture-non-tech-orgs",
    title: "How to Build a Data-Driven Culture in a Non-Tech Organization",
    by: "Mohamed Gad",
    date: "2025-08-20",
    category: "Leadership & Growth",
    topics: ["Data Culture & AI in Operations"],
    summary:
      "Data culture is a leadership practice, not a software purchase. Learn how non-technical organizations can establish shared definitions, useful habits, and decision routines that people will sustain.",
    cover_image:
      "https://er.educause.edu/-/media/images/articles/2024/04/er24_021_headerart_1600x900.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-6" */ "./Article6"),
  },
  {
    slug: "end-to-end-heart-disease-pipeline",
    title: "How to Build an End-to-End ML Pipeline with MongoDB, DVC, and MLflow",
    by: "Mohamed Gad",
    date: "2025-08-23",
    category: "AI & Machine Learning",
    topics: ["MLOps & Data Engineering"],
    summary:
      "A practical walkthrough of an end-to-end machine-learning workflow using MongoDB, DVC, and MLflow, with emphasis on reproducible data, experiment tracking, model management, and production-ready engineering habits.",
    cover_image:
      "https://www.kdnuggets.com/wp-content/uploads/2304.i039.016.F.m004.c9.AI-generated-art-AI-powered-content-creation-isometric-scaled.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-7" */ "./Article7"),
  },
  {
    slug: "turning-math-and-code-into-money",
    title: "Turning Math and Code into Money: Data Science That Pays",
    by: "Mohamed Gad",
    date: "2025-08-30",
    category: "Data & Analytics",
    topics: ["Data Science & ROI"],
    summary:
      "Technical elegance matters only when it creates useful outcomes. This article connects analytical work to revenue, savings, risk reduction, and the business cases that make data science worth funding.",
    cover_image: "https://techcrunch.com/wp-content/uploads/2016/09/robocash.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-8" */ "./Article8"),
  },
  {
    slug: "procurement-ai-agent",
    title: "Procurement AI Agent: from Kaggle CSV to Production",
    by: "Mohamed Gad",
    date: "2025-08-31",
    category: "AI & Machine Learning",
    topics: ["Data Science & ROI"],
    summary:
      "Follow the development of a procurement AI agent from an exploratory Kaggle dataset to a production-minded system, including data preparation, decision logic, evaluation, and business value.",
    cover_image:
      "https://eu-images.contentstack.com/v3/assets/bltb1db8e9b918ebe43/blte475721b7c94c556/67576655a643a9d073d33465/shutterstock_2473123561.jpg?width=1280&auto=webp&quality=80&format=jpg&disable=upscale",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-9" */ "./Article9"),
  },
  {
    slug: "waterfall-of-things",
    title: "The Waterfall of Things: a Senior Leadership Operating System",
    by: "Mohamed Gad",
    date: "2025-09-06",
    category: "Leadership & Growth",
    topics: ["Leadership"],
    summary:
      "A practical operating system for translating strategy into accountable execution. The Waterfall of Things connects leadership priorities, tactical plans, frontline work, measurement, and feedback without losing intent.",
    cover_image:
      "https://josejruiz.com/wp-content/uploads/2023/10/Waterfall-Strategy-Tactical-Operational.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-10" */ "./Article10"),
  },
  {
    slug: "lead-with-motive-data-stories",
    title:
      "Lead with Motive: How Sharp Leaders Use Descriptive, Predictive, Prescriptive, and Generative Work",
    by: "Mohamed Gad",
    date: "2025-09-11",
    category: "Leadership & Growth",
    topics: ["Leadership"],
    summary:
      "Strong analytical leadership begins with purpose. This piece shows how leaders can choose descriptive, predictive, prescriptive, or generative approaches based on the decision they actually need to make.",
    cover_image:
      "https://d3lkc3n5th01x7.cloudfront.net/wp-content/uploads/2024/01/23212247/ai-predictive-analytics.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-11" */ "./Article11"),
  },
  {
    slug: "ai-transit-outliers-trip-status-roi",
    title:
      "AI-Powered Transit Analytics: Synthetic Data, Outlier Detection, Trip Prediction, and Ethical Cost Control",
    by: "Mohamed Gad",
    date: "2025-09-14",
    category: "Transportation & Mobility",
    topics: ["Transit Analytics & AI/ML"],
    summary:
      "An applied transit analytics study combining synthetic data, anomaly detection, trip prediction, and financial modeling while keeping fairness, rider impact, and responsible cost control in view.",
    cover_image:
      "https://lh7-rt.googleusercontent.com/docsz/AD_4nXcSbUob1H1EPrlSA5ZM-r1MPCYjYyFB7s_poQ483DN4E1N7v34rvI6MtoXC57_wY5zLjddiX0O_sY4x8JVVuHvTJY5HK_vS84Zc5gIJqozTWPcvUqmcD7AGphqo1kWX0BaIv7BJCw?key=OIzKVic5Shg3l2GNc1CwywmM",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-12" */ "./Article12"),
  },
  {
    slug: "ai-dynamic-staffing-decision-intelligence",
    title:
      "From Rigid Optimization to AI-Driven Decision Intelligence: Dynamic Scheduling Beyond LP/IP",
    by: "Mohamed Gad",
    date: "2025-09-28",
    category: "Operations & Decision Systems",
    topics: ["Operations Research"],
    summary:
      "Real staffing environments rarely stay within a solver’s assumptions. This article compares classical optimization with adaptive decision intelligence for schedules that must respond to changing demand and constraints.",
    cover_image:
      "https://wp.sfdcdigital.com/en-au/wp-content/uploads/sites/12/2025/04/ai-scheduling-assistant-image.jpg?w=1024",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-13" */ "./Article13"),
  },
  {
    slug: "ai-fleet-demand-forecasting-and-operational-capacity-modeling",
    title:
      "From Statistical Modeling to AI Forecasting: A Data-Driven Framework for Fleet Capacity Optimization",
    by: "Mohamed Gad",
    date: "2025-10-12",
    category: "Transportation & Mobility",
    topics: ["AI in Operations"],
    summary:
      "A framework for turning demand forecasts into fleet capacity decisions, connecting statistical modeling, AI, service requirements, resource constraints, and the operational consequences of too much or too little capacity.",
    cover_image:
      "https://media.licdn.com/dms/image/v2/D5612AQE3U19HSmlxxw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1704169913146?e=2147483647&v=beta&t=7_T7ExUwuSsDn8NcZTFz5zTo5Yaw2o6RUdaH0gwkvS4",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-14" */ "./Article14"),
  },
  {
    slug: "ai-dispatch-and-paratransit-saas-market-evolution",
    title:
      "From Dispatch Intelligence to Full Paratransit Lifecycle: The Market and Technology Journey Behind TaxiOps",
    by: "Mohamed Gad",
    date: "2025-12-01",
    category: "Transportation & Mobility",
    topics: ["AI in Mobility & SaaS Operations"],
    summary:
      "Explore how dispatch tools can evolve into a complete paratransit operating platform, and how market needs, workflow ownership, SaaS design, and applied intelligence shaped the TaxiOps journey.",
    cover_image:
      "https://media.licdn.com/dms/image/v2/D5612AQFtnIC8yMUNTA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1713245296975?e=2147483647&v=beta&t=GGcK8lBpIIhpGFQ-B1tDpMWGJ-Bcf-31jpcd0NaneFw",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-15" */ "./Article15"),
  },
  {
    slug: "synthetic-no-show-ai-impact-analysis",
    title:
      "Predictive AI in Paratransit: Quantifying the Cost Savings of No-Show Forecasting Using Synthetic Mobility Data",
    by: "Mohamed Gad",
    date: "2025-12-15",
    category: "Transportation & Mobility",
    topics: ["AI in Public Mobility"],
    summary:
      "A quantitative look at paratransit no-show prediction using synthetic mobility data, measuring possible savings while accounting for model reliability, implementation costs, rider equity, and operational risk.",
    cover_image:
      "https://media.licdn.com/dms/image/v2/D5612AQFtnIC8yMUNTA/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1713245296975?e=2147483647&v=beta&t=GGcK8lBpIIhpGFQ-B1tDpMWGJ-Bcf-31jpcd0NaneFw",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-16" */ "./Article16"),
  },
  {
    slug: "pto-accrual-vacation-optimizer",
    title:
      "PTO Accrual Vacation Optimizer: Turning Hours Into Calendar Days With Real Policy Rules",
    by: "Mohamed Gad",
    date: "2025-12-21",
    category: "Operations & Decision Systems",
    topics: ["Workforce Planning"],
    summary:
      "A policy-aware vacation planning tool that translates accrued hours into realistic calendar options while respecting holidays, work schedules, accrual timing, organizational rules, and the employee’s desired time away.",
    cover_image:
      "https://i.ibb.co/BK2z9wpM/Chat-GPT-Image-Dec-21-2025-09-02-50-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-17" */ "./Article17"),
  },
  {
    slug: "ai-operational-demand-and-service-modeling",
    title:
      "From Queues to Intelligence: An Applied AI Methodology for Operational Demand and Service Modeling",
    by: "Mohamed Gad",
    date: "2025-12-25",
    category: "Operations & Decision Systems",
    topics: ["AI in Operations"],
    summary:
      "This applied methodology moves from queue behavior and service demand to AI-supported operational decisions, combining forecasting, capacity analysis, uncertainty, and practical controls for real service environments.",
    cover_image:
      "https://media.licdn.com/dms/image/v2/D5612AQE3U19HSmlxxw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1704169913146?e=2147483647&v=beta&t=7_T7ExUwuSsDn8NcZTFz5zTo5Yaw2o6RUdaH0gwkvS4",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-18" */ "./Article18"),
  },
  {
    slug: "learned-staffing-optimizer-beats-classical-solvers",
    title:
      "Why a Learned Staffing Optimizer Beats Classical Operations Research Solvers in the Real World",
    by: "Mohamed Gad",
    date: "2026-01-06",
    category: "Operations & Decision Systems",
    topics: ["Workforce Planning"],
    summary:
      "Classical staffing solvers can struggle when operations change faster than assumptions. This comparison shows where learned optimization can adapt better while still respecting cost, coverage, and workforce constraints.",
    cover_image:
      "https://i.ibb.co/JWWqZVYv/Chat-GPT-Image-Jan-5-2026-11-12-31-PM.png",
    render_cover: "hero",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-19" */ "./Article19"),
  },
  {
    slug: "data-science-will-change-how-the-world-solves-problems",
    title:
      "Data Science Beyond the Hype: How AI and ML Will Change How the World Solves Problems",
    by: "Mohamed Gad",
    date: "2026-01-14",
    category: "Data & Analytics",
    topics: ["Data Science Explained"],
    summary:
      "Beyond fashionable tools and inflated promises, data science changes how problems are framed, tested, and solved. This article examines the practical influence of AI and machine learning across domains.",
    cover_image:
      "https://i.ibb.co/fGnvz4Gy/Chat-GPT-Image-Jan-14-2026-11-35-25-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-20" */ "./Article20"),
  },
  {
    slug: "data-science-as-audit-superpower",
    title: "Data Science as an Audit Superpower: Turning Truth Into a Button",
    by: "Mohamed Gad",
    date: "2026-01-25",
    category: "Data & Analytics",
    topics: ["Applied Data Science & Auditing"],
    summary:
      "Applied data science can turn laborious audits into repeatable evidence systems. See how automation, reconciliation, anomaly detection, and transparent rules make financial and operational truth easier to verify.",
    cover_image:
      "https://i.ibb.co/MxSLjQSB/Chat-GPT-Image-Jan-25-2026-06-35-50-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-21" */ "./Article21"),
  },
  {
    slug: "business-first-tool-light-data-science",
    title:
      "Business First, Tool Light: Why Data Science and AI Need Directors, Not Stack Chasers",
    by: "Mohamed Gad",
    date: "2026-01-31",
    category: "Data & Analytics",
    topics: ["Applied Data Science"],
    summary:
      "Organizations need leaders who direct analytical work toward decisions, not ever-expanding technology stacks. This piece makes the case for business-first data science, focused architecture, and disciplined tool selection.",
    cover_image:
      "https://i.ibb.co/GfDbT6vW/Chat-GPT-Image-Jan-31-2026-10-20-00-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-22" */ "./Article22"),
  },
  {
    slug: "applied-ml-nemt-paratransit-operations",
    title:
      "The Algorithmic Engine: Applied Machine Learning in Paratransit and NEMT Operations",
    by: "Mohamed Gad",
    date: "2026-02-15",
    category: "Transportation & Mobility",
    topics: ["Applied Machine Learning & Transit Operations"],
    summary:
      "A practical view of machine learning inside paratransit and non-emergency medical transportation, covering demand, scheduling, routing, reliability, and the operational safeguards required around algorithmic decisions.",
    cover_image:
      "https://i.ibb.co/RTFHqtBX/Gemini-Generated-Image-8w1ezi8w1ezi8w1e.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-23" */ "./Article23"),
  },
  {
    slug: "historic-data-forecasting-and-operational-intelligence",
    title:
      "From Historical Data to Predictive Command: Building a Multi-Location Operations Dashboard",
    by: "Mohamed Gad",
    date: "2026-03-01",
    category: "Data & Analytics",
    topics: ["Operations Intelligence", "Applied Data Science", "Predictive AI/ML"],
    summary:
      "Learn how historical operating data can become a multi-location command system that combines performance monitoring, forecasting, comparison, and decision support without reducing complex operations to decorative dashboards.",
    cover_image:
      "https://i.ibb.co/VcgPJXgg/Chat-GPT-Image-Mar-1-2026-12-12-37-AM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-24" */ "./Article24"),
  },
  {
    slug: "data-science-the-executive-nuclear-weapon",
    title:
      "Data Science as Executive Command: Why Modern Leadership Must Have It Firsthand",
    by: "Mohamed Gad",
    date: "2026-03-23",
    category: "Leadership & Growth",
    topics: ["Leadership Intelligence"],
    summary:
      "Modern executives cannot delegate every analytical judgment. This argument explains why firsthand data fluency strengthens strategy, accountability, risk awareness, and the ability to challenge confident but incomplete narratives.",
    cover_image:
      "https://i.ibb.co/gZ0JM0QJ/Chat-GPT-Image-Mar-23-2026-09-38-31-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-25" */ "./Article25"),
  },
  {
    slug: "why-domain-knowledge-is-the-real-edge-in-data-science",
    title: "Why Domain Knowledge Is the Real Edge in Data Science",
    by: "Mohamed Gad",
    date: "2026-03-29",
    category: "Data & Analytics",
    topics: ["Data Science & Domain Knowledge"],
    summary:
      "Models and tools are widely available; operational context is not. This article shows why domain knowledge determines which questions matter, which patterns are credible, and which recommendations can survive reality.",
    cover_image:
      "https://i.ibb.co/PGwTgYhH/Chat-GPT-Image-Mar-29-2026-11-14-59-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-26" */ "./Article26"),
  },
  {
    slug: "building-aiplanner-fr-from-transit-data-to-a-local-planning-engine",
    title:
      "Building AIPlanner FR: Why I Spent Three Months Turning Transit Data Into a Local Planning Engine",
    by: "Mohamed Gad",
    date: "2026-04-04",
    category: "Transportation & Mobility",
    topics: ["Transit Analytics & AI & Decision Support"],
    summary:
      "The build story behind AIPlanner FR, a local transit planning engine that moves beyond analysis to schedules, operator work, route recommendations, and decision-ready outputs grounded in service data.",
    cover_image:
      "https://i.ibb.co/9kRGw22H/Chat-GPT-Image-Apr-4-2026-01-31-37-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-27" */ "./Article27"),
  },
  {
    slug: "why-most-transit-and-mobility-organizations-need-smart-automation-more-than-ai",
    title:
      "Why Most Transit and Mobility Organizations Need Smart Automation More Than AI",
    by: "Mohamed Gad",
    date: "2026-04-09",
    category: "Transportation & Mobility",
    topics: ["Transit Operations"],
    summary:
      "Many mobility organizations need reliable workflow automation before advanced AI. This article distinguishes the two, identifying where simpler systems can remove friction, improve service, and create better foundations.",
    cover_image: "https://i.ibb.co/YB29RL4K/Smart-automation-vs-AI-in-transit.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-28" */ "./Article28"),
  },
  {
    slug: "why-r-still-beats-python-in-transit-analytics",
    title: "Why R Still Beats Python in Transit Analytics",
    by: "Mohamed Gad",
    date: "2026-04-11",
    category: "Transportation & Mobility",
    topics: ["Transit Analytics (R & Python)"],
    summary:
      "A domain-specific comparison of R and Python for transit analytics, explaining where R’s statistical workflow, reporting ecosystem, and concise data manipulation can still make it the stronger operational choice.",
    cover_image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-29" */ "./Article29"),
  },
  {
    slug: "your-kpi-dashboard-is-lying-to-you",
    title: "Your KPI Dashboard Is Lying to You",
    by: "Mohamed Gad",
    date: "2026-04-16",
    category: "Data & Analytics",
    topics: ["Operational Intelligence", "KPI Design", "Data Storytelling", "Service Quality"],
    summary:
      "Polished metrics can hide operational damage. This article exposes how aggregation, framing, denominator choices, and missing context distort dashboards—and how leaders can build measures that tell the truth.",
    cover_image:
      "https://i.ibb.co/MDzbKkTq/Chat-GPT-Image-Apr-16-2026-11-13-19-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-30" */ "./Article30"),
  },
  {
    slug: "leading-through-numbers-and-nerves",
    title: "Leading Through Numbers and Nerves",
    by: "Mohamed Gad",
    date: "2026-04-26",
    category: "Leadership & Growth",
    topics: ["Operational Intelligence & Transportation Leadership"],
    summary:
      "Operational leadership requires both analytical clarity and emotional steadiness. This essay explores how leaders can use evidence under pressure without abandoning judgment, empathy, accountability, or frontline reality.",
    cover_image:
      "https://i.ibb.co/NQH8VFP/Chat-GPT-Image-Apr-27-2026-11-50-21-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-31" */ "./Article31"),
  },
  {
    slug: "taxiops-built-from-the-inside-out",
    title: "TaxiOps: Built From the Inside Out",
    by: "Mohamed Gad",
    date: "2026-05-01",
    category: "Transportation & Mobility",
    topics: ["Transportation SaaS"],
    summary:
      "TaxiOps was shaped by firsthand operating experience rather than abstract feature lists. This article explains how real dispatch, driver, customer, and management workflows informed the platform’s design.",
    cover_image:
      "https://i.ibb.co/LXLs9yY1/Chat-GPT-Image-May-1-2026-11-02-22-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-32" */ "./Article32"),
  },
  {
    slug: "future-of-transportation-operational-intelligence",
    title: "The Future of Transportation Is Operational Intelligence",
    by: "Mohamed Gad",
    date: "2026-05-09",
    category: "Transportation & Mobility",
    topics: ["Transportation", "AI", "Operational Intelligence"],
    summary:
      "Transportation’s next advantage will come from systems that understand operations continuously. This article connects AI, integrated data, workflow context, and timely decisions into a practical vision for mobility.",
    cover_image:
      "https://i.ibb.co/x8fPSZMp/Chat-GPT-Image-May-9-2026-09-05-38-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-33" */ "./Article33"),
  },
  {
    slug: "rise-of-the-operator-engineer",
    title: "The Rise of the Operator-Engineer",
    by: "Mohamed Gad",
    date: "2026-05-18",
    category: "Operations & Decision Systems",
    topics: ["Data Literacy & Leadership"],
    summary:
      "The operator-engineer combines frontline understanding with systems thinking and technical fluency. This piece describes why that hybrid role is becoming essential for designing, improving, and responsibly automating modern operations.",
    cover_image:
      "https://i.ibb.co/MxC6S6PB/Chat-GPT-Image-May-18-2026-02-49-09-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-34" */ "./Article34"),
  },
  {
    slug: "taxiops-universe-built-from-ownership",
    title: "TaxiOps: Built From Ownership, Not Observation",
    by: "Mohamed Gad",
    date: "2026-05-28",
    category: "Transportation & Mobility",
    topics: ["Transportation Technology", "Founder Story", "Operations"],
    summary:
      "A founder story about building transportation technology from direct accountability for outcomes. TaxiOps reflects problems lived across operations, not assumptions collected from a distance or copied from competitors.",
    cover_image:
      "https://i.ibb.co/mCzydZb3/Chat-GPT-Image-May-28-2026-12-20-54-AM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-35" */ "./Article35"),
  },
  {
    slug: "why-operations-leaders-must-think-like-engineers-2026",
    title: "Why Operations Leaders Must Think Like Engineers in 2026",
    by: "Mohamed Gad",
    date: "2026-06-12",
    category: "Leadership & Growth",
    topics: ["Operations Management", "AI", "Technical Rigor", "Leadership"],
    summary:
      "Modern operations leaders manage interconnected systems, not isolated task lists. This article argues for engineering habits—testing, tracing, controls, and causal thinking—alongside human leadership and operational judgment.",
    cover_image:
      "https://i.ibb.co/CpDFx0fR/Chat-GPT-Image-Jun-12-2026-11-37-39-PM.png",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-36" */ "./Article36"),
  },
  {
    slug: "getting-data-reporting-data-now-what",
    title: "Getting Data, Reporting Data... Now What?",
    by: "Mohamed Gad",
    date: "2026-06-19",
    category: "Data & Analytics",
    topics: ["Transportation", "Operations Leadership", "Data Strategy", "Decision Intelligence"],
    summary:
      "Collecting and reporting data do not automatically improve decisions. This article examines the harder step: turning visibility into interpretation, ownership, intervention, and measurable operational change.",
    cover_image:
      "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?auto=format&fit=crop&w=1600&q=80",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-37" */ "./Article37"),
  },
  {
    slug: "data-is-a-future-building-feature",
    title: "Data Is a Future-Building Feature",
    by: "Mohamed Gad",
    date: "2026-07-03",
    category: "Leadership & Growth",
    topics: ["Data Leadership", "Operations", "Execution", "Decision Intelligence", "Leadership"],
    summary:
      "Data is more than a record of what happened; it is infrastructure for what becomes possible next. This essay connects disciplined data leadership to execution, innovation, and institutional capability.",
    cover_image:
      "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=1600&q=80",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-38" */ "./Article38"),
  },
  {
    slug: "mongodb-practical-data-warehouse-transportation-operations",
    title:
      "Why MongoDB Is the Practical Data Warehouse Transportation Operations Actually Needs",
    by: "Mohamed Gad",
    date: "2026-07-21",
    category: "Transportation & Mobility",
    topics: ["Transportation", "MongoDB", "Data Architecture", "AI"],
    summary:
      "Transportation operations produce messy, changing, event-heavy data. This article explains why MongoDB can provide a practical analytical foundation for integrating workflows, preserving context, and supporting AI-ready decisions.",
    cover_image:
      "https://i.ibb.co/FqfHs1Nr/wires-in-open-server-in-data-center-cyber-securit-2026-03-11-04-14-41-utc.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-39" */ "./Article39"),
  },
  {
    slug: "your-dashboard-arrived-too-late",
    title: "Your Dashboard Arrived Too Late",
    by: "Mohamed Gad",
    date: "2026-07-26",
    category: "Operations & Decision Systems",
    topics: ["Machine Learning", "Decision Systems", "Data Strategy", "Future-Ready Business"],
    summary:
      "A dashboard that explains yesterday cannot protect today. This article explores event-driven decision systems that detect risk, recommend intervention, and bring intelligence into the operational moment.",
    cover_image:
      "https://i.ibb.co/wkCDQ4C/ai-brain-concept-with-two-people-in-background-2026-01-08-02-30-00-utc.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-40" */ "./Article40"),
  },
  {
    slug: "when-failure-becomes-intentional",
    title: "When Failure Becomes Intentional",
    by: "Mohamed Gad",
    date: "2026-08-01",
    category: "Leadership & Growth",
    topics: ["Education", "Growth", "Execution", "Personal Development"],
    summary:
      "Failure changes when it becomes a deliberate method for learning instead of an accidental outcome. This essay examines disciplined experimentation, personal growth, execution, and the courage to use setbacks intentionally.",
    cover_image:
      "https://i.ibb.co/Gv1Hb2sk/business-decision-process-concept-with-brain-and-a-2026-03-26-05-23-02-utc.jpg",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-41" */ "./Article41"),
  },
  {
    slug: "work-life-balance-is-real-so-is-responsibility",
    title: "The Space Between Balance and Responsibility",
    by: "Mohamed Gad",
    date: "2026-08-13",
    category: "Leadership & Growth",
    topics: ["Leadership", "Work-Life Balance", "Operational Responsibility", "Crisis Management"],
    summary:
      "Work-life balance protects people, but managerial accountability does not disappear after hours. This essay separates routine requests from real emergencies and shows how clear coverage, fair expectations, and disciplined escalation protect both rest and responsibility.",
    cover_image:
      "https://www.mohamedgad.com/images/articles/work-life-balance-is-real-so-is-responsibility-1280.webp",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-42" */ "./Article42"),
  },
  {
    slug: "when-every-decision-becomes-x-y-and-z",
    title:
      "The Bridge: What I Mean When I Say I Bridge Data Science With Transportation",
    by: "Mohamed Gad",
    date: "2026-08-15",
    category: "Transportation & Mobility",
    topics: [
      "Transportation Leadership",
      "Data Science",
      "Causal Reasoning",
      "Artificial Intelligence",
    ],
    summary:
      "After years in transportation, management, data science, software, and AI, these disciplines no longer feel separate. This essay defines the decision-making philosophy connecting operational reality, evidence, experimentation, prediction, causal reasoning, and human judgment.",
    cover_image:
      "https://www.mohamedgad.com/images/articles/when-every-decision-becomes-x-y-and-z-1280.webp",
    featured: false,
    loadContent: () => import(/* webpackChunkName: "article-43" */ "./Article43"),
  },
  {
    slug: "ai-is-great-automation-is-still-king",
    title: "AI Is Great. Automation Is Still King.",
    by: "Mohamed Gad",
    date: "2026-08-22",
    category: "Operations & Decision Systems",
    topics: [
      "Operations Engineering",
      "Automation",
      "Artificial Intelligence",
      "Decision Systems",
      "Operational Analytics",
    ],
    summary:
      "AI is transforming decision making, but the strongest operations automate decisions that should never require judgment in the first place. A framework for knowing when to use rules, analytics, AI, and human intelligence.",
    cover_image:
      "https://www.mohamedgad.com/images/articles/ai-is-great-automation-is-still-king-1280.webp",
    featured: true,
    loadContent: () => import(/* webpackChunkName: "article-44" */ "./Article44"),
  },
  {
  slug: "every-manager-is-running-experiments-most-just-dont-know-it",
  title: "Every Manager Is Running Experiments. Most Just Don't Know It.",
  by: "Mohamed Gad",
  date: "2026-09-07",
  category: "Operations & Decision Systems",
  topics: [
    "Operations Management",
    "Experimental Thinking",
    "Decision Science",
    "Operational Analytics",
    "Continuous Improvement",
  ],
  summary:
    "Every operational decision is effectively an experiment. A practical framework for managers to observe, form hypotheses, intervene deliberately, measure outcomes, account for confounding factors, and turn everyday management into a disciplined system of organizational learning.",
  cover_image:
    "https://www.mohamedgad.com/images/articles/every-manager-is-running-experiments-most-just-dont-know-it-1280.webp",
  featured: true,
  loadContent: () => import(/* webpackChunkName: "article-45" */ "./Article45"),
},
{
  slug: "before-you-touch-the-numbers-define-the-objective",
  title: "Before You Touch the Numbers, Define the Objective.",
  by: "Mohamed Gad",
  date: "2026-09-13",
  category: "Operations & Decision Systems",
  topics: [
    "Decision Science",
    "Operational Analytics",
    "Objective Setting",
    "Data-Driven Decision Making",
    "Strategic Management",
  ],
  summary:
    "Good analysis does not begin with a dataset. It begins with a clear objective. A practical framework for defining the outcome, separating objectives from metrics and targets, identifying the decision the analysis must support, and ensuring the numbers serve the mission rather than define it.",
  cover_image:
    "https://www.mohamedgad.com/images/articles/beforeyoutouchthenumbers.png",
  featured: true,
  loadContent: () => import(/* webpackChunkName: "article-46" */ "./Article46"),
}
];

const sourceArticles = [...legacyArticles, ...discoveredArticles];
const duplicateSlugs = sourceArticles
  .map((article) => article.slug)
  .filter((slug, index, slugs) => slugs.indexOf(slug) !== index);

if (duplicateSlugs.length > 0) {
  throw new Error(
    `Duplicate article slug${duplicateSlugs.length === 1 ? "" : "s"}: ${[
      ...new Set(duplicateSlugs),
    ].join(", ")}`
  );
}

const articleImageBase = `${process.env.PUBLIC_URL || ""}/images/articles`;
const withPublicUrl = (url) => {
  if (!url || !url.startsWith("/") || !process.env.PUBLIC_URL) return url;
  return `${process.env.PUBLIC_URL.replace(/\/$/, "")}${url}`;
};

const articles = sourceArticles.map((sourceArticle) => {
  const { cover_is_ready: coverIsReady = false, ...article } = sourceArticle;

  if (coverIsReady) {
    return {
      ...article,
      original_cover_image: article.cover_image,
      cover_image: withPublicUrl(article.cover_image),
      cover_image_srcset: article.cover_image_srcset
        ? article.cover_image_srcset
            .split(",")
            .map((candidate) => {
              const [url, width] = candidate.trim().split(/\s+/, 2);
              return `${withPublicUrl(url)}${width ? ` ${width}` : ""}`;
            })
            .join(", ")
        : undefined,
    };
  }

  return {
    ...article,
    original_cover_image: article.cover_image,
    cover_image: `${articleImageBase}/${article.slug}-1280.webp`,
    cover_image_srcset: [
      `${articleImageBase}/${article.slug}-640.webp 640w`,
      `${articleImageBase}/${article.slug}-1280.webp 1280w`,
    ].join(", "),
  };
});

const articleBySlug = new Map(articles.map((article) => [article.slug, article]));

export const getArticleMetadata = (slug) => articleBySlug.get(slug);

export default articles;
